let activeOptions = {};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getStyleProperty(element, property) {
  return window.getComputedStyle(element).getPropertyValue(property);
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityCounter extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.counterEl = this.querySelector(".js-counter-quantity");
    this.increaseBtn = this.querySelector(".js-counter-increase");
    this.decreaseBtn = this.querySelector(".js-counter-decrease");

    this.min = parseInt(this.counterEl.min) || 1;
    this.max = parseInt(this.counterEl.max) || 999;

    this.increaseBtn.addEventListener("click", this.onIncrease.bind(this));
    this.decreaseBtn.addEventListener("click", this.onDecrease.bind(this));
  }

  onIncrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (currentValue < this.max) {
      this.updateValue(currentValue + 1);
    }
  }

  onDecrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (this.dataset.cart) this.min = 0;
    if (currentValue > this.min) {
      this.updateValue(currentValue - 1);
    }
  }

  updateValue(value) {
    this.counterEl.value = value;

    this.counterEl.dispatchEvent(this.changeEvent);
  }
}

// Define the custom element
window.customElements.define("quantity-counter", QuantityCounter);

// without under functions main-password doesn't work

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function toggleTabindex(elements) {
  elements.forEach((el) => {
    const tabindex = el.getAttribute("tabindex");
    el.setAttribute("tabindex", tabindex === "0" ? "-1" : "0");
  });
}

function setTabindex(elements, tabindex) {
  elements.forEach((el) => {
    el.setAttribute("tabindex", tabindex);
  });
}

// Helper function to add multiple event listeners with the same handler
function addEventListeners(element, events, handler) {
  events.forEach((event) => element.addEventListener(event, handler));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// Safari detection
const detectSafari = () => {
  const ua = navigator.userAgent;

  const isSafari =
    ua.includes("Safari") &&
    !ua.includes("Chrome") &&
    !ua.includes("CriOS") &&
    !ua.includes("FxiOS") &&
    !ua.includes("Edg");

  const isMacOS = ua.includes("Macintosh");

  if (isSafari && isMacOS) {
    document.documentElement.classList.add("is-safari-macos");
  }
};

// Custom video controls
document.addEventListener("DOMContentLoaded", () => {
  detectSafari();

  const BUTTON_SELECTOR = ".wt-hero-video__sound-toggle";
  const BUTTON_TOGGLE_CLASS = "wt-hero-video__sound-toggle--unmuted";

  document.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
    button.addEventListener("click", () => {
      const parent = button.parentElement;
      if (!parent) return;

      let video = null;

      video = Array.from(parent.children).find((el) => el.tagName === "VIDEO");

      if (!video) {
        const heroVideoContainer = Array.from(parent.children).find(
          (el) =>
            el.classList && el.classList.contains("hero--video-background"),
        );

        if (heroVideoContainer) {
          video = heroVideoContainer.querySelector("video");
        }
      }

      if (!video) {
        const grandparent = parent.closest("video-controls");
        console.log(grandparent);
        video = Array.from(grandparent.children).find(
          (el) => el.tagName === "VIDEO",
        );
      }

      if (!video) return;

      video.muted = !video.muted;
      button.classList.toggle(BUTTON_TOGGLE_CLASS, !video.muted);
    });
  });
});

/**
 * Même origine : certains CDN (ex. Cloudflare) envoient X-Frame-Options: DENY + frame-ancestors 'none',
 * ce qui bloque iframe.src. On charge le HTML en fetch puis iframe.srcdoc (pas de navigation « frame »).
 */
window.shopIframeShouldUseSrcdoc = function (absoluteUrl) {
  const hosts = window.__shopifyIframeInternalHosts;
  if (!hosts?.length || !absoluteUrl) return false;
  try {
    const u = new URL(absoluteUrl, window.location.href);
    if (u.origin !== window.location.origin) return false;
    return hosts.includes(u.hostname);
  } catch (e) {
    return false;
  }
};

window.shopIframeLoadUrl = async function (iframe, absoluteUrl) {
  if (!iframe || !absoluteUrl) return;
  iframe.removeAttribute("srcdoc");
  iframe.setAttribute("src", "");
  const res = await fetch(absoluteUrl, {
    credentials: "same-origin",
    redirect: "follow",
    headers: { Accept: "text/html" },
  });
  if (!res.ok) throw new Error(String(res.status));
  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, "text/html");
  /* Pages produit en embed (ex. popup Échantillons) : garder les scripts pour swatches + panier */
  const keepEmbedScripts =
    /\/products\//i.test(absoluteUrl) && /(?:\?|&)embed=1(?:&|$)/i.test(absoluteUrl);
  if (!keepEmbedScripts) {
    doc.querySelectorAll("script").forEach((el) => el.remove());
  }
  doc.querySelectorAll("meta[http-equiv]").forEach((el) => {
    const h = (el.getAttribute("http-equiv") || "").toLowerCase();
    if (h === "content-security-policy") el.remove();
  });
  const head = doc.querySelector("head");
  const baseHref = new URL(absoluteUrl, window.location.href).origin + "/";
  if (head && !head.querySelector("base")) {
    const b = doc.createElement("base");
    b.setAttribute("href", baseHref);
    head.insertBefore(b, head.firstChild);
  }
  const root = doc.documentElement;
  if (root && !root.classList.contains("in-iframe")) {
    root.classList.add("in-iframe");
  }
  /* Même règles que layout/theme.liquid {% style %} — garantit header/footer masqués en srcdoc (scripts supprimés). */
  if (head) {
    const embedStyle = doc.createElement("style");
    embedStyle.setAttribute("data-shop-embed-iframe", "");
    embedStyle.textContent = `html.in-iframe #theme-header-wrapper,
html.in-iframe #theme-footer-wrapper,
html.in-iframe [id*="header-wrapper"],
html.in-iframe [id*="footer-wrapper"],
html.in-iframe header[role="banner"],
html.in-iframe footer[role="contentinfo"],
html.in-iframe .breadcrumbs__wrapper {
  display: none !important;
}
html.in-iframe .chat-toggle,
html.in-iframe #shopify-chat,
html.in-iframe sticky-buy-button,
html.in-iframe .wt-product__sticky-buy,
html.in-iframe .wt-product__gallery {
  display: none !important;
}
html.in-iframe .wt-product__wrapper,
html.in-iframe .wt-product__main,
html.in-iframe .wt-product__info {
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
@media (max-width: 749px) {
  html.in-iframe,
  html.in-iframe body {
    overflow-x: hidden;
  }
  html.in-iframe .wt-product__wrapper {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  html.in-iframe .wt-product__name {
    font-size: clamp(1.4rem, 5vw, 2rem) !important;
    line-height: 1.2;
    word-break: break-word;
  }
  html.in-iframe .echantillon-color-preview {
    max-width: min(9rem, 42vw);
    margin-bottom: 0.75rem;
  }
  html.in-iframe .vendor-logo-img {
    width: 48px !important;
  }
  html.in-iframe .swatch-couleur-metaobject-wrapper .swatch-couleur-metaobject__label {
    white-space: normal;
    max-width: none;
    font-size: 10px !important;
  }
}`;
    head.appendChild(embedStyle);
  }
  if (keepEmbedScripts && typeof window.shopInjectEchantillonsEmbedScript === "function") {
    window.shopInjectEchantillonsEmbedScript(doc);
  }
  iframe.removeAttribute("src");
  iframe.srcdoc = "<!DOCTYPE html>\n" + doc.documentElement.outerHTML;
};

/**
 * Popup Échantillons (srcdoc) : product-form.js (defer) ne s’exécute pas toujours dans l’iframe.
 * Script inline garantissant swatches + ajout panier + postMessage vers le parent.
 */
window.shopInjectEchantillonsEmbedScript = function (doc) {
  if (!doc || doc.querySelector("script[data-echantillons-embed]")) return;
  const body = doc.body || doc.documentElement;
  if (!body) return;
  const canonical = doc.querySelector('link[rel="canonical"]');
  let sectionsUrl = "/products/echantillons";
  if (canonical?.getAttribute("href")) {
    try {
      sectionsUrl = new URL(
        canonical.getAttribute("href"),
        doc.baseURI || window.location.href,
      ).pathname;
    } catch (e) {
      /* keep default */
    }
  }
  const s = doc.createElement("script");
  s.setAttribute("data-echantillons-embed", "");
  s.setAttribute("data-sections-url", sectionsUrl);
  s.textContent = `(function(){if(window.self===window.top)return;var sectionsUrl=(document.currentScript&&document.currentScript.getAttribute("data-sections-url"))||"/products/echantillons";function matchOpt(v,btn,exact){if(v==null||v==="")return false;var ov=String(v).trim().toLowerCase(),nom=(btn.dataset.colorName||"").trim().toLowerCase(),handle=(btn.dataset.colorHandle||btn.dataset.colorRal||"").trim().toLowerCase();if(nom&&ov===nom)return true;if(handle&&ov===handle)return true;if(exact)return false;if(nom&&ov.indexOf(nom)!==-1)return true;if(handle&&ov.indexOf(handle)!==-1)return true;if(nom&&handle){var c=(nom+" ral "+handle).toLowerCase();if(ov===c)return true}return false}function findVid(section,btn){if(btn.classList.contains("swatch-couleur-metaobject__swatch--payant")){var pv=parseInt(btn.getAttribute("data-variant-id")||"",10);return pv||null}var sc=section.querySelector("script[data-variants-json],script[data-color-variants-json]");if(!sc)return null;var vs;try{vs=JSON.parse(sc.textContent)}catch(e){return null}if(!vs||!vs.length)return null;var i,v;for(i=0;i<vs.length;i++){v=vs[i];if(matchOpt(v.option1,btn,true)||matchOpt(v.option2,btn,true)||matchOpt(v.option3,btn,true))return v.id}for(i=0;i<vs.length;i++){v=vs[i];if(matchOpt(v.option1,btn,false)||matchOpt(v.option2,btn,false)||matchOpt(v.option3,btn,false))return v.id}return null}function refreshVid(sid,vid){var path=sectionsUrl,sep=path.indexOf("?")>=0?"&":"?",url=window.location.origin+path+sep+"variant="+vid+"&section_id="+sid;fetch(url).then(function(r){return r.text()}).then(function(html){var doc=new DOMParser().parseFromString(html,"text/html"),root=doc.getElementById("shopify-section-"+sid)||doc.body,dest=document.getElementById("price-"+sid),src=root.querySelector("#price-"+sid);if(dest&&src)dest.innerHTML=src.innerHTML}).catch(function(){})}function syncProps(form,active){if(!form||!active)return;var hex=(active.dataset.colorHex||"").trim(),name=active.dataset.colorName||"",handle=active.dataset.colorHandle||active.dataset.colorRal||"",hi=form.querySelector('input[name="properties[_color_hex]"]'),ni=form.querySelector('input[name="properties[Couleur]"]');if(hi)hi.value=hex;if(ni){var rc=handle&&/^ral-custom/i.test(handle);ni.value=rc?name:name+(handle?" RAL "+handle:"")}}function isCartForm(form){return form&&form.tagName==="FORM"&&(form.dataset.type==="add-to-cart-form"||form.closest("product-form")||form.querySelector('input[name="id"]'))}function serializeForm(form){var pairs=[];new FormData(form).forEach(function(v,k){pairs.push({key:k,value:String(v)})});return pairs}function onSwatch(btn){var w=btn.closest("[data-swatch-couleur-metaobject]")||btn.closest(".swatch-couleur-metaobject");if(!w)return;w.querySelectorAll(".swatch-couleur-metaobject__swatch").forEach(function(b){b.classList.remove("swatch-couleur-metaobject__swatch--active")});btn.classList.add("swatch-couleur-metaobject__swatch--active");var p=w.querySelector(".echantillon-color-preview");if(p)p.style.backgroundColor=(btn.dataset.colorHex||"").trim()||"#111111";var sec=w.closest('[id^="shopify-section-"]');if(!sec)return;var sid=sec.id.replace("shopify-section-",""),form=document.getElementById("product-form-"+sid);syncProps(form,btn);var vid=findVid(sec,btn);if(vid&&form){var inp=form.querySelector('input[name="id"]');if(inp){inp.value=String(vid);inp.dispatchEvent(new Event("change",{bubbles:true}))}refreshVid(sid,vid)}}function onSubmit(e){var form=e.target;if(!isCartForm(form))return;e.preventDefault();e.stopImmediatePropagation();var active=document.querySelector(".swatch-couleur-metaobject__swatch--active");syncProps(form,active);var sb=form.querySelector('[type="submit"]');if(sb){sb.setAttribute("aria-disabled","true");sb.classList.add("loading")}window.parent.postMessage({type:"shopify:iframe:cart-add-request",pairs:serializeForm(form),sectionsUrl:sectionsUrl},"*");if(sb)setTimeout(function(){sb.removeAttribute("aria-disabled");sb.classList.remove("loading")},400)}document.addEventListener("click",function(e){var b=e.target.closest(".swatch-couleur-metaobject__swatch");if(!b)return;e.preventDefault();onSwatch(b)},true);document.addEventListener("submit",onSubmit,true);document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function(f){f.addEventListener("submit",onSubmit,true)});document.querySelectorAll(".swatch-couleur-metaobject__swatch--active").forEach(onSwatch)})();`;
  body.appendChild(s);
};
